<template>
  <div>
    <div class="flex items-center justify-between mb-6">
      <div>
        <h2 class="text-3xl font-bold text-gray-900 mb-2">
          Organization Settings
        </h2>
        <p>
          Tenant-wide feature toggles. Changes take effect on the next request.
        </p>
      </div>
    </div>

    <div v-if="loading" class="flex justify-center py-10">
      <span class="loading loading-spinner loading-lg"></span>
    </div>

    <div v-else class="bg-white shadow p-6 rounded max-w-2xl space-y-6">
      <div>
        <d-switch v-model="form.emailVerificationEnabled">
          Require Email Verification
        </d-switch>
        <p class="text-sm text-gray-600 mt-1 ml-1">
          When off, new registrants and admin-created users are marked as verified automatically
          and no verification email is sent.
        </p>
      </div>

      <div>
        <d-switch v-model="form.accountsDisabled">
          Disable Self-Service Accounts
        </d-switch>
        <p class="text-sm text-gray-600 mt-1 ml-1">
          When on, registration, login, and profile pages return not-found for this tenant.
        </p>
      </div>

      <div>
        <d-switch v-model="form.forumEnabled">
          Enable Forum
        </d-switch>
      </div>

      <div>
        <d-switch v-model="form.showNameInNav">
          Show Organization Name in Nav
        </d-switch>
      </div>

      <div>
        <d-switch v-model="form.studentGradeCheckEnabled">
          Enable Student Grade Check
        </d-switch>
      </div>

      <div class="flex justify-end pt-4 border-t">
        <d-btn
          color="primary"
          :loading="saving"
          :disabled="saving"
          @click="save"
        >
          Save Settings
        </d-btn>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { toast } from '@services/toast.service';

export default {
  name: 'OrgSettingsPage',

  data() {
    return {
      loading: true,
      saving: false,
      form: {
        emailVerificationEnabled: false,
        accountsDisabled: false,
        forumEnabled: false,
        showNameInNav: false,
        studentGradeCheckEnabled: false,
      },
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/admin/org-settings');
        this.form = {
          emailVerificationEnabled: !!data.emailVerificationEnabled,
          accountsDisabled: !!data.accountsDisabled,
          forumEnabled: !!data.forumEnabled,
          showNameInNav: !!data.showNameInNav,
          studentGradeCheckEnabled: !!data.studentGradeCheckEnabled,
        };
      } catch (error) {
        console.error('Error loading org settings:', error);
        toast.error('Failed to load organization settings');
      } finally {
        this.loading = false;
      }
    },

    async save() {
      this.saving = true;
      try {
        await axios.put('/api/admin/org-settings', this.form);
        toast.success('Organization settings saved');
      } catch (error) {
        console.error('Error saving org settings:', error);
        toast.error('Failed to save organization settings');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
